import { render, staticRenderFns } from "./PrintLegalSearch.vue?vue&type=template&id=a0ac764e&scoped=true&"
import script from "./PrintLegalSearch.vue?vue&type=script&lang=js&"
export * from "./PrintLegalSearch.vue?vue&type=script&lang=js&"
import style0 from "./PrintLegalSearch.vue?vue&type=style&index=0&id=a0ac764e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ac764e",
  null
  
)

export default component.exports